"use client"

import { usePathname } from "next/navigation"
import { AppSidebar } from "@/components/app-sidebar"
import { useAuth } from "@/contexts/auth-context"
import type { ReactNode } from "react"

interface AppShellProps {
  children: ReactNode
}

/**
 * AppShell - Persistent application shell that wraps all pages.
 *
 * Contains the new AppSidebar (Figma-based nav) that persists across routes.
 * The WorkflowHistorySidebar is preserved in the codebase for the Jobs page to reuse.
 * Hides the sidebar on the login page and when not authenticated.
 */
export function AppShell({ children }: AppShellProps) {
  const pathname = usePathname()
  const { isAuthenticated, isLoading } = useAuth()
  const showSidebar = isAuthenticated && !isLoading && pathname !== "/login"

  return (
    <main className="relative w-full h-screen overflow-hidden bg-background flex">
      {showSidebar && <AppSidebar />}
      <div className="flex-1 overflow-auto">
        {children}
      </div>
    </main>
  )
}
